import createClass from 'create-react-class'
const React = require('react')

const i18n = require('live/services/i18n')

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')
const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'googlemaps',
    active: true,
    config: {
        typeField: '__type',
        enableForInput: true,
        apiWebKey: '',
        apiWebServiceKey: ''
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const FormBase = require('live/components/extensions/ui/form')

const FormGroup = require('live/components/forms/ui/form-group')

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    makeLink: function (qualifier, path) {
        const host = location.host
        const port = location.port

        return host + '/services/plugin-extension-google' + (qualifier ? '/' + qualifier : '') + '/' + path
    },

    render(): JSX.Element {
        const object = this.state.object
        const config = object.config

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Connection config')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('api key web')}
                        name="config.apiWebKey"
                        value={config.apiWebKey}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.apiWebKey')}
                        hasFeedback
                        help={this.errorsFor('config.apiWebKey')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('api key web services')}
                        name="config.apiWebServiceKey"
                        value={config.apiWebServiceKey}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.apiWebServiceKey')}
                        hasFeedback
                        help={this.errorsFor('config.apiWebServiceKey')}
                    />
                </div>
            </FormBase>
        )
    }
})

export default Form
